import React from "react";

export const EditorialMarquee = () => {
  const words = [
    "CONFIDENCE",
    "COMMUNICATION",
    "INFLUENCE",
    "VISIBILITY",
    "LEADERSHIP",
    "CAREER GROWTH",
    "STRATEGIC POSITIONING",
    "EXECUTIVE PRESENCE",
  ];

  // Repeat twice for seamless looping
  const marqueeItems = [...words, ...words];

  return (
    <section className="bg-gold text-obsidian py-4 sm:py-6 overflow-hidden border-y border-white/10 select-none">
      <div className="relative w-full flex overflow-x-hidden">
        <div className="animate-marquee-slow whitespace-nowrap flex items-center">
          {marqueeItems.map((word, index) => (
            <div 
              key={index} 
              className="inline-flex items-center mx-6 sm:mx-12"
              data-testid={`marquee-word-${index}`}
            >
              <span className="font-display text-lg sm:text-2xl lg:text-3xl font-bold tracking-widest uppercase">
                {word}
              </span>
              <span className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-obsidian rotate-45 ml-12" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
